const isLocal = window.location.host.startsWith('local');

export function eraseFspCookie() {
  const days = -1;
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  let domain = '';
  const domains = document.location.hostname.match(
    // eslint-disable-next-line no-useless-escape
    /[a-z0-9][a-z0-9\-]+\.[a-z\.]{2,6}$/i,
  );
  domain = domains && domains[0] ? '; domain=.' + domains[0] : '';
  document.cookie = 'FspApp=' + expires + '; path=/' + domain;
}

export function redirectToLogin(
  removeCookie: boolean,
  returnUrl: string = null,
  companyId: number = null,
  eventType: string = null,
) {
  if (removeCookie) {
    if (!isLocal) {
      localStorage.clear();
    }
    eraseFspCookie();
  }
  let queryStringAdded = false;
  let redirectUrl = '/Account/Login';
  if (companyId) {
    redirectUrl += `?Company=${companyId}`;
    queryStringAdded = true;
  }
  if (returnUrl) {
    redirectUrl += `${queryStringAdded ? '&' : '?'}returnUrl=${returnUrl}`;
    queryStringAdded = true;
  }
  if (eventType) {
    redirectUrl += `${queryStringAdded ? '&' : '?'}event=${eventType}`;
    queryStringAdded = true;
  }
  window.location.replace(redirectUrl);
}

export function queryStringParams() {
  const splitSearchParams = window.location.search.substr(1).split('&');
  if (!splitSearchParams || splitSearchParams?.length === 0) return {};
  const result = {};
  for (let i = 0; i < splitSearchParams.length; ++i) {
    const param = splitSearchParams[i].split('=', 2);
    if (param.length === 1) result[param[0]] = '';
    else result[param[0]] = decodeURIComponent(param[1].replace(/\+/g, ' '));
  }
  return result;
}
